import EmptyView from "../../components/EmptyView";
import List from "../../components/List/List";
import ListItem from "../../components/List/ListItem";
import LightPageLayout from "../../components/Page/LightPageLayout";
import PageHeader from "../../components/Page/PageHeader";
import { useOutgoingRequest } from "../../data/tanstack-query";
import { getUsers } from "../../endpoints/outgoing-requests";
import { userRoute } from "./navigation";

export default function UsersPage() {
    const users = useOutgoingRequest(getUsers());
    return (
        <LightPageLayout>
            <PageHeader title="Utilisateurs" />
            <List
                items={users}
                keyExtractor={(user) => user.id}
                children={(user) => (
                    <ListItem
                        icon="users"
                        label={user.self ? `${user.label} (vous)` : user.label}
                        help={user.lastUsedAt ? formatDate(user.lastUsedAt) : "Jamais connecté"}
                        action={userRoute.getLocation({
                            pathParams: { user: user.id },
                        })}
                    />
                )}
                empty={<EmptyView message="Aucun utilisateur" />}
            />
        </LightPageLayout>
    );
}

function formatDate(value: string) {
    return new Date(value).toLocaleString("fr-FR");
}
